import dragHelper from "../../dragHelper.js";
var $ = require ('jquery')


(function ( $ ) {

    $.fn.webECG = function( options ) {

         var settings = $.extend({
            // defaults
            totalTime: 12,
            sampleRate: 1,
      			resolution: 1,
      			traceName: "",
            startFrom: 0,
			      ecgData: [],

      			ECGLineSize: 1,
      			ECGLineColor: '#ff0000',
            gridLineColor: '#ccc',
            gridInnerLineColor: '#eee',
			      drawGrid: true,
            drawInnerGrid: false,
			      drawMarks: true

        }, options );

		// Component sizing
		var width = $(this).parent(0).width();
		var height = $(this).parent(0).height();
    var canvasElement = $(this);
    dragHelper.dragging = false;


    if(width <= 0 || height <= 0){
      console.log("Parent with zero or infinity dimensions detected. Rejecting ECG calling");
      return;
    }

		$(this).width(width-50);
		$(this).height(height-50);

		// Grid constants
		const PIXEL_TIME = 0.04;

		// Grid Zoom
		const TIME_FACTOR = 25;
		var timeAmpliation = 25;
		var gainAmplification = 1;

		/*
		* INIT
		*/

		var marks = {};
    var ecgDataPoints = [];
		var marksLayer, ecgLayer, gridLayer;
		var measurements = {
			'HR':0,
			'RR':0,
			'PR':0,
			'QRS': 0,
			'QT' :0,
			'QTc':0,
			'dST':0,

      'P': 0,
      'Q': 0,
      'R1': 0,
      'R2': 0,
      'R3': 0,
      'R4': 0,
      'S': 0,
      'T': 0,
      'ST': 0
		};
		var measurementChangeCallback = function(){};

		var stage = new Konva.Stage({
			container: $(this).parent().attr('id'),
			width: width,
			height: height
		});

		gridLayer = new Konva.Layer();
		stage.add(gridLayer);

		ecgLayer = new Konva.Layer();
		stage.add(ecgLayer);

		marksLayer = new Konva.Layer();
		stage.add(marksLayer);

		/*
		* Functions - create internal components
		*/
		function createMark(x, y, text) {

			var circle = new Konva.Circle({
				radius: 10,
				stroke: '#666',
				fill: '#ddd',
				strokeWidth: 2
			});


			var simpleText = new Konva.Text({
				x: (text.length > 1) ? -8 : -4,
				y: -6,
				text: text,
				fontSize: (text.length > 1) ? 12 : 14,
				fontFamily: 'Arial',
				fill: '#666'
			});

			var baseLine = new Konva.Line({
				points: [0, 10, 0, 100],
				stroke: '#666',
				strokeWidth: 1,
				lineCap: 'round',
				lineJoin: 'round'
			});

			var group = new Konva.Group({
				x: x,
				y: y,
				draggable: true
			});

			group.msXPos = getTimefromXpos(x);

			group.on('mouseover', function() {
        dragHelper.dragging = true;
				document.body.style.cursor = 'pointer';
				this.getChildren()[0].setStrokeWidth(4);
				marksLayer.draw();

			});

			group.on('dragmove', function(event) {
				let xPos = this.getX();
				let yPos = this.getY();

				for(let c = 0; c<= ecgDataPoints.length; c = c+2){
				   if((ecgDataPoints[c]) <= xPos && (ecgDataPoints[c+2]) >= xPos){
						let points = this.getChildren()[2].getPoints();

						if(yPos - (ecgDataPoints[c+1]) < 0){
						   points[1] = 10;
						}else{
							points[1] = -10;

						}

						points[3] = -1 * (yPos - (ecgDataPoints[c+1]) );
						this.getChildren()[2].setPoints(points);

						break;
				   }
				}

				group.msXPos = getTimefromXpos(xPos);

				//recalcMarks();
			});

			group.on('mouseout', function() {
        dragHelper.dragging = false;
				document.body.style.cursor = 'default';
				this.getChildren()[0].setStrokeWidth(2);
				marksLayer.draw();
			});
			group.on('dragend', function(event) {
				//$("#mark").html(event.evt.clientX);
                recalcMarks();
			});

			group.add(circle);
			group.add(simpleText);
			group.add(baseLine);

			//Dispara evento dragmove para corrigir a altura da linha
			group.fire('dragmove');

			marksLayer.add(group);

			return group;
		}

		/*
		* Desenha o Grid do Ecg
		*/
		function drawGrid(){

			var gridPixelSize = (width / ( settings.totalTime / PIXEL_TIME ));
			//var context = gridLayer.getContext();
			//context.beginPath();

			if(settings.drawGrid){
				let cont = 0;
				for (let x = 0; x <= width; x += gridPixelSize * (timeAmpliation/TIME_FACTOR)) {

					let strokeColor = (cont % 5 == 0 ? settings.gridLineColor : settings.gridInnerLineColor);

                    if(cont % 5 == 0 || settings.drawInnerGrid){
                        let line = new Konva.Line({
                            points: [x, 0, x, height],
                            stroke: strokeColor,
                            strokeWidth: 1,
                            lineCap: 'round',
                            lineJoin: 'round'
                        });
                        gridLayer.add(line);
                    }
					cont++;

				}

				cont = 0;
				for (let y = 0; y <= height; y += gridPixelSize * gainAmplification) {

					let strokeColor = (cont % 5 == 0 ? settings.gridLineColor : settings.gridInnerLineColor);
					if(cont % 5 == 0 || settings.drawInnerGrid){
                        let line = new Konva.Line({
                            points: [0, y, width, y],
                            stroke: strokeColor,
                            strokeWidth: 1,
                            lineCap: 'round',
                            lineJoin: 'round'
                        });
                        gridLayer.add(line);
                    }
					cont++;

				}
			}
			let traceNameText = new Konva.Text({
				x: 10,
				y: 10,
				text: settings.traceName,
				fontSize: 20,
				fontFamily: 'Arial',
				fill: '#000'
			});

			gridLayer.add(traceNameText);
			gridLayer.draw();
		}


      function drawTestPoint(){
          //var context = ecgLayer.getContext();
		      //context.beginPath();

          for(let f=2; f<6000; f++){

              let line = new Konva.Line({
                  points: [10*f,50, 10*f,40],
                  stroke: "#FF0000",
                  strokeWidth: 5,
                  lineCap: 'round',
                  lineJoin: 'round'
		     });

              ecgLayer.add(line);
              //line.destroy();

          }
          //context.closePath();
		      ecgLayer.draw();
      }


		function drawECG(){

			var context = ecgLayer.getContext();
			context.beginPath();

			ecgDataPoints = [];

			var maiorPonto = -2147483648;
			var menorPonto = 2147483647;
			var linhaBase = 0;

			for(let i = 0; i< settings.ecgData.length; i++){
				if(settings.ecgData[i] > maiorPonto) maiorPonto = settings.ecgData[i];
				if(settings.ecgData[i] < menorPonto) menorPonto = settings.ecgData[i];
			}

			linhaBase = (parseFloat(maiorPonto) + parseFloat(menorPonto)) / 2;

			var gridPixelSize = (width / ( settings.totalTime / PIXEL_TIME ));
			var stepX = (width / (settings.sampleRate * settings.totalTime));
			linhaBase = linhaBase * settings.resolution * (gridPixelSize * 10);


      let startFromSecond = settings.sampleRate * settings.startFrom;

			for(let i = 0; i< settings.ecgData.length; i++){

				ecgDataPoints.push ((i-startFromSecond) * stepX * (timeAmpliation/TIME_FACTOR));
				ecgDataPoints.push( -1 * (settings.ecgData[i] * settings.resolution * (gridPixelSize * 10)) * gainAmplification + (height / 2) + linhaBase / 2);
			}

			var line = new Konva.Line({
				points: ecgDataPoints,
				stroke: settings.ECGLineColor,
				strokeWidth: settings.ECGLineSize,
				lineCap: 'round',
				lineJoin: 'round'
			});

			ecgLayer.add(line);
			ecgLayer.draw();
		}

		/*
		  * Functions, getters and setters
		*/

		function createMarks(){

      if(settings.marks != undefined){

        marks['P'] = createMark(((width * (settings.marks.P / 1000.0 )) / settings.totalTime) * (timeAmpliation / TIME_FACTOR), (height/2) - 100, 'P');
  			marks['Q'] = createMark(((width * (settings.marks.Q / 1000.0 )) / settings.totalTime) * (timeAmpliation / TIME_FACTOR), (height/2) + 100, 'Q');
  			marks['S'] = createMark(((width * (settings.marks.S / 1000.0 )) / settings.totalTime) * (timeAmpliation / TIME_FACTOR), (height/2) - 100, 'S');
  			marks['T'] = createMark(((width * (settings.marks.T / 1000.0 )) / settings.totalTime) * (timeAmpliation / TIME_FACTOR), (height/2) + 100, 'T');
  			marks['ST'] = createMark(((width * (settings.marks.ST / 1000.0 )) / settings.totalTime) * (timeAmpliation / TIME_FACTOR), (height/2) - 100, 'ST');
  			marks['R1'] = createMark(((width * (settings.marks.R1 / 1000.0 )) / settings.totalTime) * (timeAmpliation / TIME_FACTOR), (height/2) - 120, 'R1');
  			marks['R2'] = createMark(((width * (settings.marks.R2 / 1000.0 )) / settings.totalTime) * (timeAmpliation / TIME_FACTOR), (height/2) - 120, 'R2');
  			marks['R3'] = createMark(((width * (settings.marks.R3 / 1000.0 )) / settings.totalTime) * (timeAmpliation / TIME_FACTOR), (height/2) - 120, 'R3');
  			marks['R4'] = createMark(((width * (settings.marks.R4 / 1000.0 )) / settings.totalTime) * (timeAmpliation / TIME_FACTOR), (height/2) - 120, 'R4');

        recalcMarks();
      }else{
  			marks['P'] = createMark(10, 30, 'P');
  			marks['Q'] = createMark(50, 30, 'Q');
  			marks['S'] = createMark(90, 30, 'S');
  			marks['T'] = createMark(330, 30, 'T');
  			marks['ST'] = createMark(130, 30, 'ST');
  			marks['R1'] = createMark(170, 30, 'R1');
  			marks['R2'] = createMark(210, 30, 'R2');
  			marks['R3'] = createMark(250, 30, 'R3');
  			marks['R4'] = createMark(290, 30, 'R4');
      }
		}

		function fixMarksPosition(){
			let fixedXPos = 0;

			marksLayer.children.each(function(node){
				fixedXPos = ((width * (node.msXPos / 1000 )) / settings.totalTime) * (timeAmpliation / TIME_FACTOR);

				node.setX( fixedXPos );
			});
			marksLayer.draw();
		}


		$.fn.initCanvas = function() {

      gridLayer.removeChildren();
			ecgLayer.removeChildren();
      marksLayer.removeChildren();

      //drawTestPoint();
	    drawGrid();
			drawECG();

			if(options.drawMarks){
				createMarks();
        recalcMarks();

        //evento para atalho das marcações


        $('canvas').attr("tabindex", 1);

        $('canvas').on("click", function(){$('canvas').focus()});

        var cursorX;
        var cursorY;
        $('canvas').on("mousemove", function(e){
            cursorX = e.pageX - $(this).offset().left;
            cursorY = e.pageY;
        });

        $(".ecg-panel-row").keydown(function(evt) {
          //1
          if(evt.keyCode == 49){
            marks["R1"].setX(cursorX);
          }
          //2
          if(evt.keyCode == 50){
            marks["R2"].setX(cursorX);
          }
          //3
          if(evt.keyCode == 51){
            marks["R3"].setX(cursorX);
          }
          //4
          if(evt.keyCode == 52){
            marks["R4"].setX(cursorX);
          }

          //P
          if(evt.keyCode == 80){
            marks["P"].setX(cursorX);
          }
          //Q
          if(evt.keyCode == 81){
            marks["Q"].setX(cursorX);
          }
          //S
          if(evt.keyCode == 83){
            marks["S"].setX(cursorX);
          }
          //ST (tecla atalho D)
          if(evt.keyCode == 68){
            marks["ST"].setX(cursorX);
          }
          //T
          if(evt.keyCode == 84){
            marks["T"].setX(cursorX);
          }

          marksLayer.children.each(function(node){
			node.fire('dragmove');
			});
		 
          marksLayer.draw();
			recalcMarks();
          evt.preventDefault();
          return false;
        });
			}
      marksLayer.draw();
		};

    $.fn.unmount = function() {
        stage.clear();
		};

		$.fn.setGainZoom = function( zoom ) {
			if(zoom > 0){
				gainAmplification = zoom;
				redrawECG();
			}

		};
		$.fn.getGainZoom = function(  ) {
			return gainAmplification;

		};

		$.fn.setTimeZoom = function( zoom ) {
			if(zoom > 0){
				timeAmpliation = zoom;

				fixMarksPosition();
				redrawECG();


			}

		};
		$.fn.getTimeZoom = function(  ) {
			return timeAmpliation;

		};

		$.fn.onMeasurementChange = function( callback ) {

			measurementChangeCallback = callback;

		};

		$.fn.getMeasurements = function(  ) {
			return measurements;
			//Dispara evento dragmove para corrigir a altura da linha
			marksLayer.children.each(function(node){
				node.fire('dragmove');
			});
			marksLayer.draw();
		};

		$.fn.setMeasurements = function( newMeasurements ) {
			measurements = newMeasurements;

		};

		$.fn.refresh = function(  ) {
			redrawECG();
		};

		$.fn.setOption = function( opt, value ) {

			settings[opt] = value;
			redrawECG();
		};

		$.fn.getOption = function( opt ) {

			return settings[opt];
		};

		function redrawECG(){
			gridLayer.removeChildren();
			ecgLayer.removeChildren();

			drawGrid();
			drawECG();

			//Dispara evento dragmove para corrigir a altura da linha
			marksLayer.children.each(function(node){
				node.fire('dragmove');
			});
			marksLayer.draw();
		}

        $.fn.updateECG = function() {

			redrawECG();
		};

		function getMarksLength(){

			let c = 0;
			for(let mark in marks){
				c++;
			}

			return c;
		}

		function getTimefromXpos( xPos ){
			var gridPixelSize = (width / ( settings.totalTime / PIXEL_TIME ));
			return (((xPos )/gridPixelSize) * PIXEL_TIME / (timeAmpliation/TIME_FACTOR)) * 1000;

		}

		function getMvFromXpos( xPos ){

			// Posição x em milissegundos
			let xPosSeg =  getTimefromXpos( xPos );
			let ecgDataPos =  parseInt((xPosSeg * settings.ecgData.length) / (settings.totalTime * 1000));

			return (settings.ecgData[ecgDataPos] ? settings.ecgData[ecgDataPos] : settings.ecgData[ecgDataPos-1]) * settings.resolution;

		}

		function recalcMarks(){
      let HR = 0;
			let RR = 0;
			let PR = 0;
			let QRS = 0;
			let QT = 0;
			let QTc = 0;
			let dST = 0;



			//TODO trocar essa verificação pela existencia das marcações utilizadas
			if(getMarksLength() > 6){

				/* RR - média da distancia entre Rs (R2 - R1, ou (R3 - R1)/2 se R3 visivel, ou (R4 - R1)/3 se R4 visivel) */
				RR = (getTimefromXpos(marks['R2'].getX()) - getTimefromXpos(marks['R1'].getX()));
        //TODO && false adicionado para sempre ignorar marcações R3 e R4. Parametrizar no futuro.
				if (marks['R3'] && false) {
					/** R3 visivel */
					RR = (getTimefromXpos(marks['R3'].getX()) - getTimefromXpos(marks['R1'].getX())) / 2;

					if (marks['R4']) {
						/** R4 visivel */
						RR = (getTimefromXpos(marks['R4'].getX()) - getTimefromXpos(marks['R1'].getX())) / 3;
					}
				}

				/* HR - a partir do RR (intervalo médio de 1 batimento), calcula FC */
				HR = 60000 / RR;

				/* PQ ( Q - P ) */
				let pq = 0;
				if (marks['P']) {
					/** P visivel */
					pq = (getTimefromXpos(marks['Q'].getX()) - getTimefromXpos(marks['P'].getX()));
				}
				PR = pq;

				/* QRS ( S - Q ) */
				QRS = (getTimefromXpos(marks['S'].getX()) - getTimefromXpos(marks['Q'].getX()));

				/* QT ( T - Q ) */
				QT = (getTimefromXpos(marks['T'].getX()) - getTimefromXpos(marks['Q'].getX()));

				/* QTc ( QTc = corrected QT = intervalo QT (em ms) dividido pela raiz quadrada do intervalo R-R precedente (em seg) ) */
				QTc = QT / Math.sqrt(RR/1000);


				/* ST ( desnivel entre o ponto ST selecionado e a linha QT (linha base do complexo), em mm) */
				let stMv = getMvFromXpos(marks['ST'].getX());
				let stMs = getTimefromXpos(marks['ST'].getX());
				let qMv = getMvFromXpos(marks['Q'].getX());
				let qMs = getTimefromXpos(marks['Q'].getX());
				let tMv = getMvFromXpos(marks['T'].getX());
				let tMs = getTimefromXpos(marks['T'].getX());

				let ptMv = (((tMv - qMv) * (stMs - qMs)) / (tMs - qMs)) + qMv;

				let dStMv = stMv - ptMv;

				let ST = 10 * dStMv; // 1mV = 10mm


				measurements['RR'] = RR;
				measurements['HR'] = HR;
				measurements['PR'] = PR;
				measurements['QRS'] = QRS;
				measurements['QT'] = QT;
				measurements['QTc'] = QTc;
				measurements['ST'] = ST;

				measurements['P'] = getTimefromXpos(marks['P'].getX());
				measurements['Q'] = getTimefromXpos(marks['Q'].getX());
				measurements['R1'] = getTimefromXpos(marks['R1'].getX());
				measurements['R2'] = getTimefromXpos(marks['R2'].getX());
				measurements['R3'] = getTimefromXpos(marks['R3'].getX());
				measurements['R4'] = getTimefromXpos(marks['R4'].getX());
				measurements['S'] = getTimefromXpos(marks['S'].getX());
				measurements['T'] = getTimefromXpos(marks['T'].getX());
				//measurements['ST'] = getTimefromXpos(marks['ST'].getX());

				// Dispara callback - Notifica modificações nos valores
        setTimeout(function () {
          measurementChangeCallback(measurements);
        }, 300);
			}

		}
        return this;
    };
});



// WEBPACK FOOTER //
// ./src/components/ecg-web/ecg-web.js